var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('A',{staticStyle:{"color":"inherit","text-decoration":"underline","font-style":"italic"},attrs:{"HREF":_vm.glTarget,"target":"GPXPDoc"}},[_vm._v(_vm._s(_vm.glText))])
}
var staticRenderFns = []

export { render, staticRenderFns }